import { IActivityHistoryItem } from "../model";
import { Spec } from "./spec";

export class TrueSpec extends Spec<IActivityHistoryItem> {
  isSatisfiedBy(): boolean {
    return true;
  }
}
